import * as React from 'react';
import classNames from 'classnames';

import * as style from './Transition.css';

export const Transition = ({ children }: React.PropsWithChildren) => {
  const [isShown, setIsShown] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => setIsShown(true));
  });

  return <div className={classNames(style['block'], { [style['block-shown']]: isShown })}>{children}</div>;
};
